import {
  MODULOS_EXTRAS,
  createAppAbility,
  groupAbilitiesByModule,
  separateWords
} from "./chunk-QZYDLVTN.js";
import {
  CategoriaEnum,
  Categorias,
  getRoleByCategoria,
  rankingCategorias
} from "./chunk-RNAFMTTQ.js";
import {
  PermissionsNotFoundError,
  ValidationUserError
} from "./chunk-MF56YYHL.js";
import {
  RoleNotFoundError
} from "./chunk-BUN3PDXH.js";
import {
  __name
} from "./chunk-2IB33T4A.js";

// src/index.ts
import { AbilityBuilder as AbilityBuilder2 } from "@casl/ability";

// src/models/usuario.ts
import { schema } from "@acme/core";
import { z } from "zod";
var usuarioShema = schema.UsuarioSchema;
var appAbilitiesSchema = z.array(z.tuple([
  z.array(z.enum([
    "create",
    "read",
    "update",
    "delete"
  ])),
  z.string()
])).optional().nullish();

// src/permissions.ts
import { AbilityBuilder } from "@casl/ability";
var permissions = {
  P\u00FAblico(_user, { can }) {
    can("read", "Planos");
    can("read", "Checkout");
  },
  Administrador(_user, { can }) {
    can("create", "Clientes");
    can("read", "Clientes");
    can("update", "Clientes");
    can("read", "Par\xE2metrosFinanceiros");
    can("create", "Par\xE2metrosFinanceiros");
    can("update", "Par\xE2metrosFinanceiros");
    can("read", "Logs");
    can([
      "read",
      "delete"
    ], "Hist\xF3ricoDeLogin");
    can("read", "Dashboard");
    can([
      "read",
      "update"
    ], "Perfil");
    can("read", "Dashboard--Items");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Usu\xE1rios");
    can("read", "Auditoria");
  },
  Suporte(user, ability) {
    this.Administrador(user, ability);
    const { cannot } = ability;
    cannot([
      "create",
      "update"
    ], "Par\xE2metrosFinanceiros");
    cannot([
      "read",
      "update",
      "create",
      "delete"
    ], "Usu\xE1rios");
    cannot("read", "Auditoria");
    cannot("update", "Clientes");
  },
  Cliente(user, ability) {
    this.P\u00FAblico(user, ability);
    const { can } = ability;
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "CentrosDeCusto");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Empresas", {
      clienteId: {
        $eq: user.clienteId
      }
    });
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Escalas", {
      clienteId: {
        $eq: user.clienteId
      }
    });
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Feriados");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Funcion\xE1rios");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Locais");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Ocorr\xEAncias");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "RegrasDeC\xE1lculo");
    can([
      "read",
      "update"
    ], "Rubricas");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Supervisores");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "TabelaDeHor\xE1rios");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Permiss\xF5es");
    can("read", "AjustesDePonto");
    can([
      "read"
    ], "Aus\xEAncias");
    can([
      "read",
      "update",
      "create",
      "delete"
    ], "C\xE1lculoDoPonto");
    can([
      "read"
    ], "Digita\xE7\xE3o");
    can([
      "read",
      "create"
    ], "FechamentoDeCompet\xEAncia");
    can([
      "read",
      "update",
      "create",
      "delete"
    ], "Implanta\xE7\xE3oDoBancoDeHoras");
    can([
      "read",
      "update"
    ], "PagamentoDeHoras");
    can([
      "read",
      "update",
      "create",
      "delete"
    ], "Sobreaviso");
    can([
      "read",
      "create",
      "delete"
    ], "TrocaDeDiaDeTrabalho");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "TrocaDeTabelaDeHor\xE1rio");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "TrocaAutom\xE1ticaDeHor\xE1rio");
    can([
      "read",
      "create",
      "update",
      "delete"
    ], "Compensa\xE7\xE3oManual");
    can([
      "read",
      "update",
      "create",
      "delete"
    ], "AEJ");
    can([
      "read",
      "create"
    ], "AFD");
    can("read", "ExportarFuncion\xE1rios");
    can([
      "read",
      "create"
    ], "FolhaDePagamento");
    can("read", "ImportarFuncion\xE1rios");
    can([
      "read",
      "update",
      "create",
      "delete"
    ], "Reps");
    can("read", "Absente\xEDsmo");
    can("read", "AceiteDoEspelhoDoPonto");
    can("read", "AdicionalNoturno");
    can("read", "Ajustes");
    can([
      "read",
      "create",
      "delete"
    ], "AssinaturaEletr\xF4nicaDeAjustes");
    can("read", "SaldoDeHoras");
    can("read", "DescontoDeDSR");
    can("read", "EspelhoDoPonto");
    can("update", "EspelhoDoPonto");
    can("read", "ComprovanteDePonto");
    can("read", "Inconsist\xEAncias");
    can("read", "RegistrosExclu\xEDdos");
    can("read", "RegistrosForaDaCerca");
    can("read", "TrocasDeHor\xE1rio");
    can([
      "read",
      "update"
    ], "ValeAlimenta\xE7\xE3o");
    can("read", "HorasTrabalhadas");
    can("read", "HorasSuprimidas");
    can("read", "PontoDi\xE1rio");
    can("read", "Dashboard--Items");
    can("read", "RelatorioFaltasAtrasos");
    can("read", "AtendimentoOnline");
    can("read", "PrimeirosPassos");
    can("read", "Manual");
    can("read", "Altera\xE7\xF5es");
    can("read", "AtestadoDeCapacidadeT\xE9cnica");
    can([
      "read",
      "delete"
    ], "Hist\xF3ricoDeLogin");
    can("read", "Dashboard");
    can([
      "read",
      "update"
    ], "Perfil");
    can([
      "create",
      "update",
      "delete"
    ], "Registros");
    can([
      "create",
      "update",
      "delete"
    ], "Abonos");
    can([
      "create",
      "update",
      "delete"
    ], "Afastamentos");
    can([
      "create",
      "update",
      "delete"
    ], "Compensa\xE7\xE3o");
    can([
      "create",
      "update",
      "delete"
    ], "Amamenta\xE7\xE3o");
    can([
      "create",
      "update",
      "delete"
    ], "Folga");
    can([
      "create",
      "update",
      "delete"
    ], "Compensa\xE7\xE3oDeFeriados");
    can([
      "create",
      "update",
      "delete"
    ], "Compensa\xE7\xE3oDeFolgas");
    can([
      "create",
      "update",
      "delete"
    ], "FaltasJustificadasOuInjustificadas");
  },
  Supervisor(user, ability, profileAbilities) {
    const { cannot, can } = ability;
    can("read", "Dashboard--Items");
    if (profileAbilities) {
      can("read", "AtendimentoOnline");
      can("read", "PrimeirosPassos");
      can("read", "Manual");
      can([
        "read",
        "delete"
      ], "Hist\xF3ricoDeLogin");
      can("read", "Dashboard");
      can([
        "read",
        "update"
      ], "Perfil");
      const defaultAbilities = new AbilityBuilder(createAppAbility);
      this.Supervisor(user, defaultAbilities, void 0);
      const supervisorAbilities = defaultAbilities.build();
      for (const [actions, subject] of profileAbilities) {
        if (Array.isArray(actions)) {
          for (const action of actions) {
            if (supervisorAbilities.can(action, subject)) can(action, subject);
          }
        } else {
          if (supervisorAbilities.can(actions, subject)) can(actions, subject);
        }
      }
    } else {
      this.Cliente(user, ability);
      cannot("read", "Checkout");
      cannot([
        "read",
        "update",
        "create",
        "delete"
      ], "Supervisores");
      cannot([
        "update",
        "create",
        "delete"
      ], "Empresas");
      cannot([
        "delete",
        "update",
        "create"
      ], "Escalas");
      cannot([
        "read",
        "update",
        "create",
        "delete"
      ], "Permiss\xF5es");
    }
  },
  Funcion\u00E1rio(_user, { can }) {
    can("read", "Digita\xE7\xE3o");
    can("read", "Ajustes");
    can([
      "read",
      "update"
    ], "AssinaturaEletr\xF4nicaDeAjustes");
    can("read", "ComprovanteDePonto");
    can("read", "DescontoDeDSR");
    can("read", "EspelhoDoPonto");
    can("create", "AceiteDoEspelhoDoPonto");
    can("read", "SelecionarFuncion\xE1rio");
    can([
      "read",
      "delete"
    ], "Hist\xF3ricoDeLogin");
    can("read", "Dashboard");
    can([
      "read",
      "update"
    ], "Perfil");
  },
  Avalia\u00E7\u00E3o(user, ability) {
    this.Cliente(user, ability);
  },
  Representante(user, { can }) {
    can("read", "Clientes", {
      criadorId: {
        $eq: user.id
      }
    });
    can("create", "Clientes", {
      criadorId: {
        $eq: user.id
      }
    });
    can("update", "Clientes", {
      criadorId: {
        $eq: user.id
      }
    });
    can([
      "read",
      "update"
    ], "Perfil");
    can([
      "read",
      "delete"
    ], "Hist\xF3ricoDeLogin");
    can("read", "Dashboard");
    can("read", "Dashboard--Items");
  }
};

// src/index.ts
function defineAbilitiesFor(props) {
  const validation = usuarioShema.pick({
    categoriaId: true
  }).safeParse(props);
  const userAbilitiesValidation = appAbilitiesSchema.safeParse(props.userAppAbilities);
  if (!validation.success) {
    console.error(validation.error.flatten());
    throw new ValidationUserError(validation.error);
  }
  const usuario = validation.data;
  const builder = new AbilityBuilder2(createAppAbility);
  const role = getRoleByCategoria(usuario.categoriaId);
  if (!role) throw new RoleNotFoundError(usuario.categoriaId);
  if (typeof permissions[role] !== "function") {
    throw new PermissionsNotFoundError(usuario.categoriaId);
  }
  permissions[role](usuario, builder, userAbilitiesValidation.data ?? void 0);
  for (const modulo of Object.values(MODULOS_EXTRAS).map((it) => it.subject)) {
    let rules;
    if (rules = builder.rules.filter((rule) => rule.subject === modulo)) {
      if (!props.modulos?.includes(modulo)) for (const rule of rules) builder.cannot(rule.action, rule.subject);
    }
  }
  if (props.isAtivo === false) {
    let handleSingleAction2 = function(action, subject) {
      if (action === "create") builder.cannot(action, subject);
      else if ([
        "update",
        "delete"
      ].includes(action) && subject !== "Funcion\xE1rios") builder.cannot(action, subject);
    };
    var handleSingleAction = handleSingleAction2;
    __name(handleSingleAction2, "handleSingleAction");
    const rules = structuredClone(builder.rules);
    for (const rule of rules) {
      if (Array.isArray(rule.action)) {
        for (const action of rule.action) handleSingleAction2(action, rule.subject);
      } else handleSingleAction2(rule.action, rule.subject);
    }
  }
  const ability = builder.build({
    detectSubjectType(subject) {
      return subject.__typename;
    }
  });
  return ability;
}
__name(defineAbilitiesFor, "defineAbilitiesFor");
export {
  CategoriaEnum,
  Categorias,
  RoleNotFoundError,
  appAbilitiesSchema,
  defineAbilitiesFor,
  getRoleByCategoria,
  groupAbilitiesByModule,
  rankingCategorias,
  separateWords
};
//# sourceMappingURL=index.js.map